// extracted by mini-css-extract-plugin
export var equalColumn = "_i4-0";